// /mnt/mantenimientos/frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";

import App from "./App";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";

import "./Supervisor.css";

class AppErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) { console.error("Mantenimientos render error", error); }
  render() {
    if (!this.state.error) return this.props.children;
    const message = String(this.state.error?.message || "Error de renderizado").replace(/[\r\n]+/g, " ").slice(0, 280);
    return <main className="saas saas-full" style={{ padding: 24 }}><section className="card"><h2>No se pudo mostrar esta vista</h2><p className="muted">La aplicación sigue disponible. Error: <code>{message}</code></p><button className="button primary" type="button" onClick={() => { this.setState({ error: null }); window.location.assign("/app"); }}>Volver al panel</button></section></main>;
  }
}

// Compatibilidad con pantallas heredadas que usan axios directamente.
axios.interceptors.request.use((config) => {
  const url = String(config.url || "");
  const isInternalApi = url.startsWith("/api/") && url !== "/api/auth";
  const token = String(localStorage.getItem("token") || "").trim();

  if (isInternalApi && token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

function LoginRoute() {
  return (
    <Login
      onLoginSuccess={() => {
        // Unificamos todo en un solo panel
        window.location.href = "/app";
      }}
    />
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AppErrorBoundary>
    <BrowserRouter>
      <Routes>
      {/* Login */}
      <Route path="/" element={<LoginRoute />} />

      {/* Panel único (técnico/supervisor/admin) */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        }
      />

      {/* Compatibilidad: rutas antiguas -> /app */}
      <Route path="/tecnico" element={<Navigate to="/app" replace />} />
      <Route path="/supervisor" element={<Navigate to="/app" replace />} />
      <Route path="/supervisor/login" element={<Navigate to="/" replace />} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </AppErrorBoundary>
);
